import { render, staticRenderFns } from "./homeColor.vue?vue&type=template&id=28ad36d8&scoped=true"
import script from "./homeColor.vue?vue&type=script&lang=js"
export * from "./homeColor.vue?vue&type=script&lang=js"
import style0 from "./homeColor.vue?vue&type=style&index=0&id=28ad36d8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ad36d8",
  null
  
)

export default component.exports